import Login from '../pages/auth/Login.jsx'
import MainAuth from '../pages/auth/Login/MainAuth.jsx';
import Dashboard from '../pages/dashboard/Dashboard.jsx';
import MultiOrderScreen from '../pages/dashboard/MultiOrderScreen.jsx'

export const initialRoutes = () => [
  // Auth Routes
  {
    path: "/",
    type: "auth",
    // component: Login,
    component: MainAuth,
    title: "Login",
  },
  {
    path: "/dashboard",
    type: "private",
    component: Dashboard,
    title: "Dashboard",
  },
  {
    path: "*",
    type: "private",
    component: Dashboard,
    title: "Dashboard",
  },

];

